import { Box } from "@mui/material";
import {
  HeaderWrapper,
  ProgressBar,
  ProgressContainer,
  ProgressFill,
  StepText,
} from './style';

interface ProgressHeaderProps {
  currentStep: number;
  totalSteps?: number;
}

export const ProgressHeader = ({
  currentStep,
  totalSteps = 2,
}: ProgressHeaderProps) => {
  return (
    <HeaderWrapper>
      {currentStep === 3 ? null : (
        <>
           <ProgressContainer>
           {Array.from({ length: totalSteps }).map((_, index) => {
             const step = index + 1;

          return (
            <ProgressBar key={step}>
              <ProgressFill
                initial={false}
                animate={{
                  width: currentStep >= step ? "100%" : "0%",
                }}
                transition={{
                  duration: 0.6,
                  ease: [0.25, 0.1, 0.25, 1],
                }}
              />
            </ProgressBar>
          );
        })}
      </ProgressContainer>

      <Box display="flex" alignItems="center">
        <StepText>
          Etapa {currentStep} de {totalSteps}
        </StepText>
      </Box>
        </>
      )}
    
    </HeaderWrapper>
  );
};
